import SuperFetch from '../../superFetch.js';
import { AuthRequest } from '../../../types/common/AuthType';
import SuperFetchV2 from '../../superFetchV2';

interface IAuthApi {
  data: AuthRequest;
  isSpinner?: boolean;
}

class AuthApi {
  /**
   *  로그인
   */
  login = (data: IAuthApi) => SuperFetch.post('/auth/login', data);
  fetchProfile = () => SuperFetchV2.get('/auth/profile');
}

export default new AuthApi();
